[
  {
    "id": "MET-E7P-L206-001",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Een aquarium is 80 cm lang, 40 cm breed en 50 cm hoog. Het is voor 90% gevuld. Hoeveel liter water zit erin?",
    "options": [
      "144 liter",
      "160 liter",
      "120 liter",
      "150 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-AQUARIUM",
    "explanation": "Inhoud totaal: 8 × 4 × 5 = 160 dm³ = 160 liter. 90% daarvan: 0,9 × 160 = 144 liter.",
    "distractorExplanations": {
      "1": "Dit is als hij helemaal vol zit.",
      "2": "Dit is 75% gevuld.",
      "3": "Schattingsfout."
    }
  },
  {
    "id": "MET-E7P-L206-002",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Reken om: 12 m/s = ... km/u",
    "options": [
      "43,2 km/u",
      "36 km/u",
      "40 km/u",
      "120 km/u"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-MS-KMU",
    "explanation": "Van m/s naar km/u is vermenigvuldigen met 3,6. 12 × 3,6 = 43,2 km/u.",
    "distractorExplanations": {
      "1": "10 × 3,6 = 36.",
      "2": "Schattingsfout.",
      "3": "Je hebt met 10 vermenigvuldigd."
    }
  },
  {
    "id": "MET-E7P-L206-003",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Hoeveel weegt 1 m³ water?",
    "options": [
      "1.000 kg",
      "100 kg",
      "10 kg",
      "1 kg"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-WATER-GEWICHT",
    "explanation": "1 liter water weegt 1 kg. 1 m³ is 1.000 liter, dus 1.000 kg (= 1 ton).",
    "distractorExplanations": {
      "1": "Dat is 100 liter.",
      "2": "Dat is 10 liter.",
      "3": "Dat is 1 liter."
    }
  },
  {
    "id": "MET-E7P-L206-004",
    "module": "Metriek",
    "difficulty": 206,
    "question": "De schaal is 1 : 50.000. Je fietst 15 km. Hoeveel cm is dat op de kaart?",
    "options": [
      "30 cm",
      "15 cm",
      "3 cm",
      "7,5 cm"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "schaal",
    "familyId": "MET-SCHAAL-TERUG",
    "explanation": "15 km = 1.500.000 cm. 1.500.000 : 50.000 = 30 cm.",
    "distractorExplanations": {
      "1": "Rekenfout.",
      "2": "Je hebt een nul te veel weggestreept.",
      "3": "Rekenfout."
    }
  },
  {
    "id": "MET-E7P-L206-005",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Reken om: 0,025 ha = ... m²",
    "options": [
      "250 m²",
      "25 m²",
      "2.500 m²",
      "25.000 m²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-HA-M2-KOMMA",
    "explanation": "1 ha = 10.000 m². 0,025 × 10.000 = 250 m².",
    "distractorExplanations": {
      "1": "Je hebt met 1.000 vermenigvuldigd.",
      "2": "Je hebt met 100.000 vermenigvuldigd.",
      "3": "Je hebt met 1.000.000 vermenigvuldigd."
    }
  },
  {
    "id": "MET-E7P-L206-006",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Een zwembad is 50 m lang, 20 m breed en 1,5 m diep. Het is voor 80% gevuld. Hoeveel liter water zit erin?",
    "options": [
      "1.200.000 liter",
      "1.500.000 liter",
      "150.000 liter",
      "120.000 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-ZWEMBAD-80",
    "explanation": "Inhoud: 50 × 20 × 1,5 = 1.500 m³ = 1.500.000 liter. 80%: 0,8 × 1.500.000 = 1.200.000 liter.",
    "distractorExplanations": {
      "1": "Dat is 100% gevuld.",
      "2": "Je vergat om te rekenen naar liter (×1.000).",
      "3": "Je rekende 80% van 150.000 in plaats van 1.500.000."
    }
  },
  {
    "id": "MET-E7P-L206-007",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Een kaart heeft schaal 1 : 25.000. Twee steden liggen 8 cm uit elkaar op de kaart. Hoeveel km is dat in werkelijkheid?",
    "options": [
      "2 km",
      "20 km",
      "0,2 km",
      "200 km"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "schaal",
    "familyId": "MET-SCHAAL-KM",
    "explanation": "8 cm × 25.000 = 200.000 cm = 2.000 m = 2 km.",
    "distractorExplanations": {
      "1": "Je maakte een fout bij het omrekenen van cm naar km.",
      "2": "Je deelde door 25.000 in plaats van te vermenigvuldigen.",
      "3": "Je vergat te delen door 100.000 om km te krijgen."
    }
  },
  {
    "id": "MET-E7P-L206-008",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Een vrachtwagen rijdt 80 km/u. Hoeveel meter per seconde is dat? (afrond op geheel getal)",
    "options": [
      "22 m/s",
      "80 m/s",
      "8 m/s",
      "30 m/s"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-KMU-MS-E7P",
    "explanation": "Van km/u naar m/s: delen door 3,6. 80 : 3,6 = 22,2... ≈ 22 m/s.",
    "distractorExplanations": {
      "1": "Dat is de snelheid in km/u.",
      "2": "Je deelde door 10 in plaats van 3,6.",
      "3": "Schattingsfout."
    }
  },
  {
    "id": "MET-E7P-L206-009",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Een tuin is 20 m lang en 12 m breed. Er komt een pad van 2 m breed rondom. Wat is de oppervlakte van alleen het pad?",
    "options": [
      "144 m²",
      "240 m²",
      "384 m²",
      "96 m²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-PAD-E7P",
    "explanation": "Buitenmaat: (20+4) × (12+4) = 24 × 16 = 384 m². Tuin: 20 × 12 = 240 m². Pad: 384 - 240 = 144 m².",
    "distractorExplanations": {
      "1": "Dat is de oppervlakte van de tuin zelf.",
      "2": "Dat is de totale oppervlakte inclusief tuin en pad.",
      "3": "Je berekende de omtrek van de buitenmaat."
    }
  },
  {
    "id": "MET-E7P-L206-010",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Reken om: 0,45 m³ = ... cl",
    "options": [
      "45.000 cl",
      "4.500 cl",
      "450 cl",
      "450.000 cl"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-M3-CL-E7P",
    "explanation": "0,45 m³ = 450 liter. 1 liter = 100 cl. 450 × 100 = 45.000 cl.",
    "distractorExplanations": {
      "1": "Je deed 450 × 10.",
      "2": "Je vergat om te rekenen van liter naar cl.",
      "3": "Je deed 450 × 1.000."
    }
  },
  {
    "id": "MET-E7P-L206-011",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Een bak water weegt 15 kg. De lege bak weegt 3 kg. Hoeveel liter water zit erin?",
    "options": [
      "12 liter",
      "15 liter",
      "18 liter",
      "3 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-WATER-BAK",
    "explanation": "Gewicht water: 15 - 3 = 12 kg. 1 liter water weegt 1 kg. Dus 12 liter.",
    "distractorExplanations": {
      "1": "Je vergat het gewicht van de bak eraf te trekken.",
      "2": "Je telde het gewicht van de bak erbij op.",
      "3": "Dat is het gewicht van de bak, niet het water."
    }
  },
  {
    "id": "MET-E7P-L206-012",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Een stuk grond is 0,8 hectare. Hoeveel are is dat?",
    "options": [
      "80 are",
      "8 are",
      "800 are",
      "0,8 are"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-HA-ARE-E7P",
    "explanation": "1 ha = 100 are. 0,8 × 100 = 80 are.",
    "distractorExplanations": {
      "1": "Je deed ×10.",
      "2": "Je deed ×1.000.",
      "3": "Je zette niets om."
    }
  },
  {
    "id": "MET-E7P-L206-013",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Een cilindervormig glas heeft een inhoud van 250 ml. Hoeveel glazen kun je vullen uit een bak van 0,03 m³?",
    "options": [
      "120 glazen",
      "12 glazen",
      "1.200 glazen",
      "30 glazen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-GLAZEN",
    "explanation": "0,03 m³ = 30 liter = 30.000 ml. 30.000 : 250 = 120 glazen.",
    "distractorExplanations": {
      "1": "Je vergat om te rekenen naar ml.",
      "2": "Je deed 30.000 : 25 in plaats van : 250.",
      "3": "Je rekende 30 liter : 1 = 30."
    }
  },
  {
    "id": "MET-E7P-L206-014",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Reken om: 7.200 cm² = ... dm²",
    "options": [
      "72 dm²",
      "7,2 dm²",
      "720 dm²",
      "0,72 dm²"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte_omrekenen",
    "familyId": "MET-CM2-DM2-E7P",
    "explanation": "1 dm² = 100 cm². 7.200 : 100 = 72 dm².",
    "distractorExplanations": {
      "1": "Je deelde door 1.000.",
      "2": "Je deelde door 10.",
      "3": "Je deelde door 10.000."
    }
  },
  {
    "id": "MET-E7P-L206-015",
    "module": "Metriek",
    "difficulty": 206,
    "question": "Een fietser rijdt 24 km/u. Hoeveel minuten doet hij over 10 km?",
    "options": [
      "25 minuten",
      "24 minuten",
      "20 minuten",
      "30 minuten"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid_tijd",
    "subSkill": "snelheid",
    "familyId": "MET-SNELHEID-MIN",
    "explanation": "Tijd = afstand : snelheid = 10 : 24 = 0,4167 uur. 0,4167 × 60 = 25 minuten.",
    "distractorExplanations": {
      "1": "Dat is de snelheid, niet de tijd.",
      "2": "Je deed 10 : 30 × 60.",
      "3": "Je deed 10 : 20 × 60."
    }
  }
]